import { render } from "./FooterPublic.vue?vue&type=template&id=de31338e"
import script from "./FooterPublic.vue?vue&type=script&lang=js"
export * from "./FooterPublic.vue?vue&type=script&lang=js"

import "./FooterPublic.vue?vue&type=style&index=0&id=de31338e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__